import { ToastProps as RadixToastProps } from '@radix-ui/react-toast';
import React from 'react';

export enum Variant {
  error = 'error',
  success = 'success',
  loading = 'loading',
  info = 'info',
  plain = 'plain',
  warning = 'warning'
}

export enum ToastPlacement {
  top = 'top',
  bottom = 'bottom'
}

export type VariantType = `${Variant}`;

export type ToastPlacementType = `${ToastPlacement}`;
export type ToastProps = Omit<RadixToastProps, 'content'> & {
  content: React.ReactNode;
  closeable?: boolean;
  isRelative?: boolean;
  duration?: number;
  variant: VariantType;
  width?: string;
  placement?: ToastPlacementType;
  open?: boolean;
  onClose?: () => void;
  actions?: React.ReactNode;
  draggable?: boolean;
  showIcon?: boolean;
  contentStyle?: React.CSSProperties;
  'data-test-id'?: string;
};

export type ToastUtilReturnType = {
  update: (props: Partial<ToastProps>) => void;
  close: () => void;
};

type ToastSubUtilProps = Omit<ToastProps, 'variant'>;

export type UtilType = (props: ToastSubUtilProps) => ToastUtilReturnType;

export type ToastUtil = {
  (props: ToastProps): ToastUtilReturnType;
  success: UtilType;
  error: UtilType;
  loading: UtilType;
  info: UtilType;
  plain: UtilType;
  closeAll: () => void;
};
